import z from 'zod';

import { parseEnv } from '@nohara-dxdev/react-core';

export const env = parseEnv({
  HOME_API_ENDPOINT: z.url(),
  API_ENDPOINT: z.url(),
  OAUTH_DOMAIN: z.string(),
  APP_ID: z.uuid(),
  USER_POOL_ID: z.string(),
  USER_POOL_WEB_CLIENT_ID: z.string(),
  OIDC_CALLBACK_PATH: z.string().default('/oauth/callback'),
  SIGN_OUT_PATH: z.string().default('/logout'),
  BACKEND_VERSION: z.string().default(''),
  FRONTEND_VERSION: z.string().default(''),
});
